const createMockFunction = () =>
  typeof jest !== 'undefined'
    ? jest.fn().mockImplementation(() => Promise.resolve({}))
    : () => Promise.resolve({});

export const mockFocusPointApi = {
  create: createMockFunction(),
  update: createMockFunction(),
  updateAllForQuestion: createMockFunction(),
  remove: createMockFunction(),
}
